import React from 'react';
import Grid from '@material-ui/core/Grid';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import CreatePartner from '../../components/CreatePartner';
import { siteMetadata } from '../../constants';

export default function CreatePartnerPage() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{`${t('components.createPartner.title')} | ${
          siteMetadata.TITLE
        }`}</title>
      </Helmet>
      <Grid container>
        <Grid item xs={12} md={6}>
          <CreatePartner />
        </Grid>
      </Grid>
    </>
  );
}
